import { HttpMethods, makeRequest } from '../helpers/http.helper';
import type { DayOfWeek, OrganizationWeekSchedule, TruckWeekSchedule } from '../types/routeSchedule.type';

interface GenericResponse<T> {
  result: T;
}

export async function getTruckSchedule(truckId: string): Promise<TruckWeekSchedule> {
  const response = await makeRequest({
    url: `/route_schedule/truck/${truckId}`,
    method: HttpMethods.GET,
  }) as GenericResponse<TruckWeekSchedule>;
  return response.result;
}

/** Fleet-wide week schedule for every truck in the org (Task 1's new endpoint). */
export async function getOrganizationSchedule(organizationId: string): Promise<OrganizationWeekSchedule> {
  const response = await makeRequest({
    url: `/route_schedule/organization/${organizationId}`,
    method: HttpMethods.GET,
  }) as GenericResponse<OrganizationWeekSchedule>;
  return response.result;
}

/**
 * Sets the full ordered list of routes for one weekday in one call --
 * `routeIds`' array order becomes the server-side sequence. Min length 1: an
 * empty array is rejected by the backend with 422 -- use `clearScheduleDay`
 * to actually clear a day, never call this with `[]` to mean "clear."
 */
export async function setScheduleDay(
  truckId: string,
  dayOfWeek: DayOfWeek,
  routeIds: string[],
): Promise<TruckWeekSchedule> {
  const response = await makeRequest({
    url: `/route_schedule/truck/${truckId}/day/${dayOfWeek}`,
    method: HttpMethods.PUT,
    data: { route_ids: routeIds },
  }) as GenericResponse<TruckWeekSchedule>;
  return response.result;
}

/** The backend returns a bare `{ ok: true }` here -- no `GenericResponse` wrapper, no schema. */
export async function clearScheduleDay(truckId: string, dayOfWeek: DayOfWeek): Promise<void> {
  await makeRequest({
    url: `/route_schedule/truck/${truckId}/day/${dayOfWeek}`,
    method: HttpMethods.DELETE,
  });
}
